<div class="entity-config-page land-court-page land-court-overview-page container-fluid px-0 py-0 py-lg-1">
  <div class="entity-config-shell d-flex flex-column gap-3 mx-auto px-4 py-3">
    <section class="entity-config-top rounded-4 overflow-hidden">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h4 class="fw-bold lh-sm mb-0">Overview Dashboard</h4>
          </div>
        </div>
      </div>
    </section>

    <section class="land-court-overview-surface land-court-superset-surface rounded-4 border-0">
      <div
        v-if="dashboard_loading"
        class="land-court-empty-state land-court-superset-state rounded-4 px-4 py-5 text-center"
      >
        <div class="fw-semibold mb-1">Loading overview...</div>
        <div class="small text-secondary">Fetching the embedded Superset dashboard.</div>
      </div>

      <div
        v-if="dashboard_error"
        class="land-court-empty-state land-court-superset-state rounded-4 px-4 py-5 text-center"
      >
        <div class="fw-semibold mb-1">Dashboard unavailable</div>
        <div class="small text-secondary">{{ dashboard_error }}</div>
        <button
          type="button"
          class="btn btn-sm btn-primary mt-3"
          @click="embed_superset_dashboard"
        >
          Retry
        </button>
      </div>

      <div
        ref="superset_dashboard_mount"
        class="land-court-superset-dashboard"
        :class="{ 'd-none': dashboard_loading || dashboard_error }"
      ></div>
    </section>
  </div>
</div>
